module.exports = __webpack_public_path__ + "static/media/icon_testresults_grey.7dd2bec5.svg";